<template>
  <div>
    <v-card flat class="custom-grey-border remove-border-radius mt-4">
      <!-- Header -->
      <v-card-title
        class="headline grey lighten-4 d-flex justify-content-between"
      >
        <h3 class="font-weight-700 custom-headline color-custom-blue m-0">
          Import History
        </h3>
      </v-card-title>

      <!-- Table -->
      <v-card-text class="p-6 font-size-16">
        <v-row>
          <v-col cols="12">
            <v-simple-table
              class="simple-table"
              fixed-header
              :height="paginatedHistoryList?.length ? 'auto' : '150px'"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="simple-table-th px-2" width="200">Date</th>
                    <th class="simple-table-th px-2">File Name</th>
                    <th class="simple-table-th px-2">Status</th>
                    <th class="simple-table-th px-2">Records</th>
                    <th class="simple-table-th px-2" width="150">Action</th>
                  </tr>
                </thead>

                <!-- Rows -->
                <tbody v-if="paginatedHistoryList?.length">
                  <tr
                    v-for="(history, index) in paginatedHistoryList"
                    :key="index"
                    class="alternate-listing-row"
                  >
                    <!-- Date -->
                    <td class="simple-table-td">
                      {{ history?.added_at || "--" }}
                    </td>

                    <!-- File Name -->
                    <td class="simple-table-td text-capitalize">
                      {{ history?.file_name }}
                    </td>

                    <!-- Status -->
                    <td class="simple-table-td">
                      <template v-if="history?.status">
                        <v-chip
                          small
                          :color="getStatusColor(history.status)"
                          class="px-3 white--text"
                          style="height: 24px"
                        >
                          {{ history.status }}
                        </v-chip>
                      </template>
                      <em v-else class="text-muted">no status</em>
                    </td>

                    <!-- Records -->
                    <td class="simple-table-td">
                      {{ history?.records || "--" }}
                    </td>

                    <!-- Action -->
                    <td class="simple-table-td"  @click="downloadReport(history)">
                      <v-icon color="cyan" size="20">mdi-download</v-icon>
                      <span class="ml-1">Download Report</span>
                    </td>
                  </tr>
                </tbody>

                <!-- Empty State -->
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="py-4">
                      <div class="text-center">
                        <img
                          :src="$assetURL('media/error/empty.png')"
                          class="row-not-found-image mb-2"
                        />
                        <p class="row-not-found font-weight-500 font-size-16">
                          Uhh... There is no import history at the moment.
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row
              justify="end"
              class="align-center pagination_btn listing-footer px-2"
              >
                <p class="m-0 listing-footer-count">
                <template v-if="historyList.length > 0">
                  Showing
                  {{ (currentPage - 1) * itemsPerPage + 1 }}
                  to
                  {{ Math.min(currentPage * itemsPerPage, historyList.length) }}
                  of
                  {{ historyList.length }} entries
                </template>
                <template v-else>
                  Showing 0 to 0 of 0 entries
                </template>
                </p>
                <v-spacer></v-spacer>
                <v-pagination
                  v-model="currentPage"
                  :length="pageCount"
                  total-visible="7"
                  color="cyan"
                  @input="handlePageChange"
                ></v-pagination>
              </v-row>  
      </v-card-text>
    </v-card>
  </div>
</template>
<script>

import { GET} from "@/core/services/store/request.module";
import JwtService from "@/core/services/jwt.service"; 
export default {
  name: "ImportHistory",
  data() {
    return {
      zoneId : 0,
      historyList : [],
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  methods: {

    getHistories(id)
    {

      console.log(id);
        const _this = this;
        _this.$store.dispatch(GET, {
          url: "get-import-histories/" + id,
        }).then((response) => {
          this.historyList = response.data;
      
        }).catch((error) => {
          _this.logError(error);
        })

    },

     getStatusColor(status) {
      switch (status) {
        case 'success':
          return 'green';
        case 'partial':
          return 'orange';
        case 'failed':
          return 'red';
        default:
          return 'grey';
      }
    },

     handlePageChange(page) {
      this.currentPage = page;
    },

    downloadReport(history) {

      const token = JwtService.getToken();
      const url = this.$apiURL + 'public/' + history.file_path + '?token=' + token;
      console.log(url);
      window.open(url, "_blank");

    }

  },

  watch: {
      '$route.params.id'(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.zoneID = newVal;
          this.getHistories(newVal);
        }
      },
  },  

  computed:{

    pageCount() {
        return Math.ceil(this.historyList.length / this.itemsPerPage);
    },

     paginatedHistoryList() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.historyList.slice(start, end);  
    },

  },


  created()
  {
    this.zoneID = this.$route.params.id;
    
  },

   mounted() {
     this.getHistories(this.zoneID);
  },

};
</script>
